import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./Authprovider";
import { Loader, getFirstGrantedAdminPath } from "@b2b/ui-components";

interface SimplePrivateLayoutProps {
  allowedRoles?: ("buyer" | "seller" | "admin")[];
}

const SimplePrivateLayout: React.FC<SimplePrivateLayoutProps> = ({
  allowedRoles = ["buyer", "seller", "admin"],
}) => {
  const {
    isAuthenticated,
    isLoading,
    isSessionProfileLoading,
    userStatus,
    userRole,
    sessionEmail,
    allowedModules,
  } = useAuth();
  const location = useLocation();

  if (isLoading || (isAuthenticated && isSessionProfileLoading)) {
    return <Loader size={40} color="#f97316" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (userStatus === "not_registered" || userStatus === "pending_registration") {
    return (
      <Navigate
        to="/login?tab=signup"
        replace
        state={{
          fromOAuth: true,
          prefilledEmail: sessionEmail,
        }}
      />
    );
  }

  // Check if user role is allowed
  if (userRole && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (userRole === "admin" && allowedModules !== undefined) {
    return <Navigate to={getFirstGrantedAdminPath(allowedModules)} replace />;
  }

  // Simple layout without sidebar/header - just render the children
  return <Outlet />;
};

export default SimplePrivateLayout;

